import { FilePlus, Play, Redo2, Save, Trash2, Undo2 } from "lucide-react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { Stack } from "@mui/material";
import { useWorkflowCommandsContext } from "@src/components/Dialogs/CmdKDialog/useWorkflowCommandsContext";
import { WorkflowCommands } from "@src/contexts/WorkflowCommandsContext";

import { SearchOption } from "./types";
import { tokenizedMatches } from "./utils";

const WORKFLOW_COMMANDS: {
  key: keyof WorkflowCommands;
  label: string;
  Icon: React.ComponentType<{ size?: number }>;
}[] = [
  { key: "onSave", label: "Save Workflow", Icon: Save },
  { key: "onExecute", label: "Execute Workflow", Icon: Play },
  { key: "onUndo", label: "Undo", Icon: Undo2 },
  { key: "onRedo", label: "Redo", Icon: Redo2 },
  { key: "onClear", label: "Clear Workflow", Icon: Trash2 },
  { key: "onNewWorkflow", label: "New Workflow", Icon: FilePlus },
];

export const useWorkflowCommandOptions = (
  query?: string,
  limit?: number
): SearchOption[] => {
  const { commands } = useWorkflowCommandsContext();

  const candidates = WORKFLOW_COMMANDS.flatMap(({ key, label, Icon }) => {
    const handler = commands[key];
    if (!handler) {
      return [];
    }
    return [{ label, Icon, handler }];
  });

  if (!candidates.length) {
    return [];
  }

  const filtered = query
    ? candidates.filter(({ label }) =>
        tokenizedMatches(query.toLowerCase(), label.toLowerCase())
      )
    : candidates;

  return (limit ? filtered.slice(0, limit) : filtered).map(
    ({ label, Icon, handler }) => ({
      group: "Workflow",
      render: () => (
        <Stack direction="row" alignItems="center">
          <Icon size={20} />
          <IgTypography marginLeft={2}>{label}</IgTypography>
        </Stack>
      ),
      select: handler,
    })
  );
};
